import { render, staticRenderFns } from "./performante_timeline_stat.vue?vue&type=template&id=2527d4a8&scoped=true&"
import script from "./performante_timeline_stat.vue?vue&type=script&lang=js&"
export * from "./performante_timeline_stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527d4a8",
  null
  
)

export default component.exports